import Client from "./clients/rest";

export default {

    getCoupons(businessId, object) {
        const query = new URLSearchParams(JSON.parse(JSON.stringify(object, (k,v) => v ?? undefined))).toString()
        return Client.get(`business/${businessId}/get_coupons?language=1&site=3&ShowInActive=true${query ? '&' + query : ""}`);
    },

    getCoupon(businessId,menuItemId) {
        return Client.get(`business/${businessId}/get_coupon?language=1&site=3&pageSize=1&pageNumber=1&ShowInActive=true${menuItemId? `&menuItemId=${menuItemId}`:""}`);
    },

    menuItemsByType(businessId,typeId) {
        return Client.get(`business/${businessId}/menu_items_by_type?language=1&site=3&typeId=${typeId}`);
    },
};
